import React from 'react';
import { createRoot } from 'react-dom/client';
import { Conversations } from './components/Conversations';
import './index.css';

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error("Root container not found");
}
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Conversations />
  </React.StrictMode>,
);
